import * as React from 'react';
import clsx from 'clsx';
import * as types from 'src/types';
import useView from 'src/hooks/useView';
import { WaterCoolerItem, WaterCoolerItemType } from './WaterCoolerItem';
import { StyledHeading } from '../ui/styledHeading/styledHeading';
import * as scss from './WaterCooler.module.scss';
import { getStrapiImageSource } from '../../utils/strapiDataHelpers';

export type Props = {
  data: {
    backgroundImage?: types.ImageFields;
    headline: types.TextFields;
    footerContent?: string;
    content: WaterCoolerItemType[];
  };
  id?: string;
};

export const WaterCooler = ({ data, id }: Props) => {
  // hooks
  const view = useView();

  // render
  return (
    <section id={id} className={clsx(scss.section)}>
      {data.backgroundImage != null && data.backgroundImage.src[view] && (
        <div className={clsx(scss.sectionBg)}>
          <img
            src={getStrapiImageSource(
              data.backgroundImage.src[view] as types.ImageSource
            )}
            alt={data.backgroundImage.alt}
          />
        </div>
      )}
      <div className={clsx(scss.container)}>
        <div className={clsx(scss.header)}>
          <StyledHeading hasSwoosh={false}>{data.headline.text}</StyledHeading>

          {data.footerContent && (
            <div
              className={clsx(scss.subheadline)}
              dangerouslySetInnerHTML={{
                __html: data.footerContent,
              }}
            />
          )}
        </div>
        <div className={clsx(scss.row)}>
          {data.content.map((item, i) => (
            <div key={i} className={clsx(scss.col)}>
              <WaterCoolerItem data={item} isOdd={i % 2 === 0} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
